<template>
    <div style="line-height: 1.7em">
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
            </v-snackbar>
            <div v-if="istemplateApplicable">
                <span v-html="rawhtmlcode"></span>
            </div>
        <!-- <v-card class="box card" flat v-if="leraner_marksheet != ''">
            <v-row justify="center" class="page-top">
                <v-col cols="12" sm="12" md="12">
                    <v-row v-if="org_basic_data.school_logo" dense justify="center">
                        <img :src="org_basic_data.school_logo" style="height: 20%;width: 20%;" alt="logo" />
                    </v-row>
                    
                    <v-row v-if="org_basic_data.trust_name" dense justify="center">
                        <strong><h5>{{ org_basic_data.trust_name }}</h5></strong>
                    </v-row>
                    <v-row dense v-if="org_basic_data.school_name" justify="center">
                        <strong><h1>{{ org_basic_data.school_name }}</h1></strong>
                    </v-row>
                    <v-row v-if="org_basic_data.address" dense justify="center">
                        <h5>{{ org_basic_data.address }}</h5>
                    </v-row>
                    <v-row dense justify="center" v-if="org_basic_data.email && org_basic_data.phone">
                        <h5>
                            Phone : {{ org_basic_data.phone }} <span class="pl-2"></span> Email : {{
                            org_basic_data.email }}
                        </h5>
                    </v-row>
                    <v-row v-if="org_basic_data.website" dense justify="center">
                        <h5>Website : {{ org_basic_data.website }}</h5>
                    </v-row>
                    <v-row v-if="org_basic_data.cbsc_no" dense justify="center"><h5>CBSE Affiliation No: {{ org_basic_data.cbsc_no }}</h5></v-row>

                </v-col>
            </v-row>
            <v-row dense justify="center" class="tech-remark" style="margin-top: -10px">
                <span class="text_report">
                    <strong class="print-font"
                        ><v-col cols="12" sm="12" md="12"> Assessment Report A.Y. {{ ay }}</v-col>
                    </strong>
                </span>
            </v-row>
            <v-row dense class="stud-info font-size">
                <v-col cols="12" sm="12" md="12" v-if="photo != null">
                    <center>
                        <img class="ml-5" :src="awspath + photo" style="width: 160px; height: 160px" alt="logo" />
                    </center>
                </v-col>
                <v-col cols="12" sm="12" md="12" v-else>
                    <center>
                        <img
                            class="ml-5"
                            src="https://eduplusschool.s3.ap-south-1.amazonaws.com/User_avatar.jpeg"
                            style="width: 160px; height: 160px"
                            alt="logo"
                        />
                    </center>
                </v-col>
                <v-row dense justify="center">
                     <v-col cols="12" sm="12" md="12" justify="center" align="center">
                         <hr style="width: 50%; border-width: 1px; color: black; background-color: black; border-style: solid;" />
                        <strong>Name : </strong> {{ name }}
                        <hr style="width: 50%; border-width: 1px; color: black; background-color: black; border-style: solid;" />
                    </v-col>
                     
                     <v-col cols="12" sm="12" md="12" justify="center" align="center"><strong>Roll No. : </strong> {{ roll_no }}  <hr style="width: 50%; border-width: 1px; color: black; background-color: black; border-style: solid;" /></v-col>
                     <v-col cols="12" sm="12" md="12" justify="center" align="center"><strong>Class & Section : </strong>{{ standard }} {{ div }} <hr style="width: 50%; border-width: 1px; color: black; background-color: black; border-style: solid;" /></v-col>
                     <v-col cols="12" sm="12" md="12" justify="center" align="center"><strong>PRN : </strong>{{ reg_no }} <hr style="width: 50%; border-width: 1px; color: black; background-color: black; border-style: solid;" /></v-col>
                     <v-col cols="12" sm="12" md="12" justify="center" align="center"><strong>House : </strong>{{ house }} <hr style="width: 50%; border-width: 1px; color: black; background-color: black; border-style: solid;" /></v-col>
                     <v-col cols="12" sm="12" md="12" justify="center" align="center"><strong>Date of Birth : </strong> {{ dob }}  <hr style="width: 50%; border-width: 1px; color: black; background-color: black; border-style: solid;" /></v-col>
                     <v-col cols="12" sm="12" md="12" justify="center" align="center"><strong>G.R. No. : </strong> {{ gr_no }} <hr style="width: 50%; border-width: 1px; color: black; background-color: black; border-style: solid;" /></v-col>
                     <v-col cols="12" sm="12" md="12" justify="center" align="center"><strong>Blood Group : </strong> {{ blood_group }} <hr style="width: 50%; border-width: 1px; color: black; background-color: black; border-style: solid;" /></v-col>
                     <v-col cols="12" sm="12" md="12" justify="center" align="center"><strong>Name Of Class Teacher : </strong> {{ inst_name }} <hr style="width: 50%; border-width: 1px; color: black; background-color: black; border-style: solid;" /></v-col>
                     <v-col cols="12" sm="12" md="12" justify="center" align="center">
                    <strong>Residential Address : </strong>
                        <span>
                            {{ address }}
                        </span> <hr style="width: 50%; border-width: 1px; color: black; background-color: black; border-style: solid;" />
                    </v-col>
                </v-row>
            </v-row>
            <div class="table-breaked pagebreak">
                <v-simple-table
                    dense
                    class="marksheet-table"
                    v-for="course in leraner_marksheet.learner_scholastic_marksheet_data"
                    :key="course.course"
                >
                    <thead>
                        <tr>
                            <th colspan="2"><h2 style="font-weight: bolder;">{{ course.course }}</h2></th>
                            <th v-for="eva in course.assessments" :key="eva"><h2 style="font-weight: bolder;">{{ eva }}</h2></th>
                            <th><h2 style="font-weight: bolder;">Final Assessment</h2></th>
                        </tr>
                    </thead>

                    <tbody v-for="section in course.sections" :key="section.section">
                        Section Header
                        <tr v-if="section.section">
                            <td colspan="100%" class="section-title">{{ section.section }}</td>
                        </tr>

                        Rows
                        <tr v-for="row in section.rows" :key="row.rubric">
                            <td colspan="2">
                                <strong>{{ row.rubric }}</strong>
                            </td>

                            EVA Columns
                            <td v-for="key in getAssessmentKeys(course, row)" :key="key">
                                {{ (row.marks && row.marks[key]) || '-' }}
                            </td>

                            Final Assessment
                           <td>{{ row.final_grade }}</td>
                        </tr>
                    </tbody>
                </v-simple-table>
                <v-simple-table
                    dense
                    class="marksheet-table"
                    v-for="course in leraner_marksheet.leraner_coscholastic_marksheet_data"
                    :key="course.course"
                >
                    <thead>
                        <tr>
                            <th colspan="2"><h2 style="font-weight: bolder;">{{ course.course }}</h2></th>
                            <th v-for="eva in course.assessments" :key="eva"><h2 style="font-weight: bolder;">{{ eva }}</h2></th>
                            <th><h2 style="font-weight: bolder;">Final Assessment</h2></th>
                        </tr>
                    </thead>

                    <tbody v-for="section in course.sections" :key="section.section">
                        <tr v-for="row in section.rows" :key="row.rubric">
                            <td colspan="2">
                                <strong>{{ row.rubric }}</strong>
                            </td>

                            <td v-for="eva in course.assessments" :key="eva">
                                {{ (row.marks && row.marks[eva]) || '-' }}
                            </td>
                            <td>{{ row.final_grade }}</td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </div>
            <v-row class="tech-remark font-size" dense justify="center">
                <v-row dense justify="center" class="tech-remark" style="margin-top: -10px">
                    <span class="text_report">
                        <strong class="print-font"
                            ><v-col cols="12" sm="12" md="12">Health Details A.Y. {{ ay }}</v-col>
                        </strong>
                    </span>
                </v-row>
                <v-col cols="12" sm="12" md="12">
                    <v-simple-table v-if="leraner_marksheet != ''" fixed-header dense class="elevation-1">
                        <thead>
                        <tr>
                            <td rowspan="3">
                                <center><strong>Health Status</strong></center>
                            </td>
                            <td colspan="3">
                                <center>
                                    <strong>{{ leraner_marksheet.sem1 }}</strong>
                                </center>
                            </td>
                            <td colspan="3">
                                <center>
                                    <strong>{{ leraner_marksheet.sem2 }}</strong>
                                </center>
                            </td>
                        </tr>
                        <tr>
                            <td><center>Height (cm)</center></td>
                            <td><center>Weight (kg)</center></td>
                            <td><center>BMI</center></td>
                            <td><center>Height (cm)</center></td>
                            <td><center>Weight (kg)</center></td>
                            <td><center>BMI</center></td>
                        </tr>
                        <tr>
                            <td v-for="(s, index2) in leraner_marksheet.user_bmi_list_sem1" :key="index2">
                                <center>{{ s }}</center>
                            </td>
                            <td v-for="(s, index2) in leraner_marksheet.user_bmi_list_sem2" :key="index2">
                                <center>{{ s }}</center>
                            </td>
                        </tr>
                    </v-simple-table>
                </v-col>
                <v-row dense justify="center" class="tech-remark" style="margin-top: -10px">
                    <span class="text_report">
                        <strong class="print-font"
                            ><v-col cols="12" sm="12" md="12">Attendance Details A.Y. {{ ay }}</v-col>
                        </strong>
                    </span>
                </v-row>
                <v-col cols="12" sm="12" md="12">
                    <v-simple-table v-if="leraner_marksheet != ''" fixed-header dense class="elevation-1">
                        <thead>
                            <tr>
                                <td><center>Attendance</center></td>
                                <td>
                                    <center>{{ leraner_marksheet.sem1 }}</center>
                                </td>
                                <td>
                                    <center>{{ leraner_marksheet.sem2 }}</center>
                                </td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    <center>
                                        <strong>Total Attendance of the Student</strong>
                                    </center>
                                </td>
                                <td v-for="(s, index2) in leraner_marksheet.sem1_attendance" :key="index2">
                                    <center>{{ s.present }} / {{ s.total_working_stud }}</center>
                                </td>
                                <td v-for="(s, index2) in leraner_marksheet.sem2_attendance" :key="index2">
                                    <center>{{ s.present }} / {{ s.total_working_stud }}</center>
                                </td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-col> <br><br><br>
                <v-col cols="12" sm="12" md="12">
                    <span class="mr-2" style="border-bottom: 3px solid #000; padding-bottom: 3px">{{ name }} </span>
                    is Passed and Promoted to
                    <span style="border-bottom: 3px solid #000; padding-bottom: 3px"
                        >Grade {{ leraner_marksheet.next_std }}</span
                    >
                </v-col>
               <v-col cols="12" sm="12" md="12">
                    New session begins on :
                    <span class="mr-2" style="border-bottom: 3px solid #000; padding-bottom: 3px"
                        >{{ leraner_marksheet.sessiondate_std }}</span
                    >
                </v-col>
            </v-row>
            <br /><br /><br /><br /><br /><br />
            <v-col cols="12" sm="12" md="12">
                <v-row dense justify="center" class="tech-remark font-size">
                    <v-col cols="12" sm="4" md="4"> Date : {{ leraner_marksheet.lms_result_date }} </v-col>
                    <v-col cols="12" sm="4" md="4"> Signature of Class Teacher </v-col>
                    <v-col cols="12" sm="4" md="4"> Signature of Principal </v-col>
                </v-row>
            </v-col>
             <div class="pagebreak">
            <v-row dense justify="center">
                <v-col cols="12" sm="12" md="12">
                    <center>
                        <strong>
                            Scholastic Areas (Grading on {{ leraner_marksheet.scholastic_grade }} Point Scale)
                        </strong>
                        <br />
                        <v-simple-table class="elevation-1" dense style="width: 400px">
                            <thead>
                                <tr>
                                    <td class=""><center>Sr. No.</center></td>
                                    <td class=""><center>Grade Name</center></td>
                                    <td class=""><center>Percentage Range</center></td>
                                    <td class=""><center>Grade Point</center></td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(s, index) in leraner_marksheet.grade_details" :key="s.g_id">
                                    <td>
                                        <center>{{ index + 1 }}</center>
                                    </td>
                                    <td>
                                        <center>{{ s.gradename }}</center>
                                    </td>
                                    <td>
                                        <center>{{ s.range }}</center>
                                    </td>
                                    <td>{{s.gradepoint}}</td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </center>
                </v-col>
                <v-col cols="12" sm="12" md="12" v-if="leraner_marksheet.cograde_details.length > 0">
                    <center>
                        <strong>
                            Co-Scholastic Areas (Grading on {{ leraner_marksheet.coscholastic_grade }} Point Scale)
                        </strong>
                        <v-simple-table
                            fixed-header
                            dense
                            class="elevation-1"
                            style="width: 400px"
                            v-if="leraner_marksheet.cograde_details.length > 0"
                        >
                            <thead>
                                <tr>
                                    <td class=""><center>Sr. No.</center></td>
                                    <td class=""><center>Grade Name</center></td>
                                    <td class=""><center>Grade Point</center></td>
                                    <td class=""><center>Grade Point</center></td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(s, index) in leraner_marksheet.cograde_details" :key="s.g_id">
                                    <td>
                                        <center>{{ index + 1 }}</center>
                                    </td>
                                    <td>
                                        <center>{{ s.gradename }}</center>
                                    </td>
                                    <td>
                                        <center>{{ s.range }}</center>
                                    </td>
                                    <td>{{s.gradepoint}}</td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </center>
                </v-col>
            </v-row>
            </div>
        </v-card> -->
        
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </div>
</template>
<script>
    import axios from "axios";
    import jsPDF from "jspdf";
    import "jspdf-autotable";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        props: {
            org: Number,
        },
        data() {
            return {
                default_value: [],
                dialog_marks: false,
                overlay: false,
                selected: [],
                snackbar: false,
                search: "",
                snackbar_msg: "",
                color: "",
                snackbar: false,
                ay_std_div_list: null,
                sel_ay_data: null,
                semester_list: null,
                sem: null,
                fetch_loader: false,
                show: false,
                course_list: [],
                stud_list: [],
                awspath: "",
                registration_no: null,
                standard: null,
                div: null,
                ay: null,
                name: null,
                dob: null,
                roll_no: null,
                mobile_no: null,
                address: null,
                mother_name: null,
                photo: null,
                reg_no: null,
                gr_no: null,
                father_full_name: null,
                leraner_marksheet: [],
                semester: null,
                colspan: null,
                overall_grade: null,
                remark: [],
                org_basic_data: [],
                sem1: null,
                sem2: null,
                mother_contact: null,
                father_contact: null,
                allowedStandards: ["I", "II", "III", "IV", "V"],
                NotAllowedStandardsForTables: ["I", "II"],
                blood_group:null,
                house:null,
                inst_name: null,
                rawhtmlcode: [],
                istemplateApplicable: false,
                std:null,
                div:null,
                org:null,
                status: ''
            };
        },

        methods: {
            getAssessmentKeys(course, row) {
                // If row has marks → use its own keys
                if (row && row.marks && Object.keys(row.marks).length) {
                    return Object.keys(row.marks);
                }

                // Fallback to course-level assessments
                return course.assessments || [];
            },
            print() {
                this.$store.state.drawer = false;
                let that = this;
                window.onafterprint = function () {
                    that.$store.state.drawer = true;
                };
                setTimeout(function () {
                    window.print();
                }, 100);
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            onload() {
                this.overlay = true;
                const data = {
                    lid: this.registration_no,
                    ay: this.sel_ay_data,
                    sem: this.sem,
                    org: this.org,
                };
                console.log("data:", data);
                axios
                    .post("/Examination/getAnnualStudentReportTemplate", data)
                    .then((res) => {
                        if (res.data.flag == "NO") {
                            this.showSnackbar("#b71c1c", res.data.smsg); // show snackbar
                            this.overlay = false;
                            return;
                        }
                        if (res.data.flag == "YES") {
                            this.standard = res.data.standard;
                            this.div = res.data.div;
                            this.ay = res.data.ay;
                            this.name = res.data.name;
                            this.dob = res.data.dob;
                            this.roll_no = res.data.roll_no;
                            this.mobile_no = res.data.mobile_no;
                            this.address = res.data.address;
                            this.mother_name = res.data.mother_name;
                            this.photo = res.data.photo;
                            this.reg_no = res.data.reg_no;
                            this.gr_no = res.data.gr_no;
                            this.blood_group = res.data.blood_group
                            this.house = res.data.house
                            this.father_full_name = res.data.father_full_name;
                            this.leraner_marksheet = res.data.leraner_marksheet;
                            this.inst_name = res.data.inst_name
                            // console.log(this.leraner_marksheet)
                            this.semester = res.data.semester;
                            this.default_value = res.data.default_value;
                            this.org_basic_data = res.data.org_basic_data;
                            this.mother_contact = res.data.mother_contact;
                            this.father_contact = res.data.father_contact;
                            this.overlay = false;
                            this.rawhtmlcode = res.data.output;          
                            this.istemplateApplicable = res.data.istemplateApplicable;
                        }
                        if (res.data.flag == "NO") {
                            this.showSnackbar("#b71c1c", res.data.msg_flag); // show snackbar
                            this.overlay = false;
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                        this.overlay = false;
                    })
                    .finally(() => {});
            },
            handleBulk() {
                this.overlay = true;

                const payload = {
                    ay: this.sel_ay_data,
                    sem: this.sem,
                    standard: this.std,
                    division: this.div,
                    org: this.org,
                    status: this.status,
                };
                
                axios.post("/Examination/getAnnualStudentReportTemplateBulk", payload)
                    .then((res) => {
                        if (res.data.flag === "YES") {                            
                            this.rawhtmlcode = res.data.output;
                            this.istemplateApplicable = true;
                            this.overlay = false;
                        }
                        else if(res.data.flag === "NO"){
                            this.showSnackbar("#b71c1c", res.data.msg);
                            this.overlay = false;
                            return;
                        }                        
                    })
                    .catch(() => {
                        this.showSnackbar("#b71c1c", "Something went wrong...");
                        this.overlay = false;
                    })
                    .finally(() => {
                        // cleanup
                    });
            }
        },
        mounted() {
            this.awspath = localStorage.getItem("awspath");
            this.sel_ay_data = localStorage.getItem("setay");
            this.sem = localStorage.getItem("setsem");
            this.std = localStorage.getItem("setstd");
            this.div = localStorage.getItem("setdiv");
            this.org = localStorage.getItem("EPS-org-id");
            this.status = localStorage.getItem("status");
            // this.registration_no = localStorage.getItem("setreg_no");
            // this.onload();
            const isBulk = localStorage.getItem("isBulk");
            if (isBulk === "true") {
                this.handleBulk();
            } else {
                this.registration_no = localStorage.getItem("setreg_no");
                this.onload();
            }
        },
    };
</script>
<style scoped>
    tr,
    td,
    th {
        border: 1px solid black;
        /* text-align: center; */
        /* font-size: small; */
    }
    tr,
    tbody {
        border: 1px solid black;
        /* font-size: small; */
    }
    .marksheet-table {
        margin-bottom: 30px;
        border: 1px solid #ccc;
    }

    .section-title {
        background: #f5f5f5;
        font-weight: bold;
        text-align: left;
    }

    th {
        background: #eee;
        font-weight: bold;
        text-align: center;
    }

    td {
        text-align: center;
        font-size: 13px;
    }

    @media print and (-webkit-min-device-pixel-ratio: 0) {
        .print-font {
            font-size: 20px !important;
        }
        .v-data-table__wrapper {
            overflow-x: hidden;
            overflow-y: hidden;
        }
        .card {
            border: none !important;
            font-size: large !important;
            margin-top: -25px !important;
        }
        .page-top {
            padding-top: 10px !important;
        }
        hr{
            width: 80% !important;
        }
        .pagebreak {
            page-break-before: always;
        }
        .full-height {
            height: 93vh;
        }
        header,
        footer,
        nav,
        date {
            display: none !important;
        }

        .no-display,
        .v-input__control,
        input[type="button"],
        input[type="submit"],
        input[type="reset"],
        #v-card {
            display: none !important;
        }
        v-card {
            border: none !important;
        }
        .div {
            width: 1450px !important;
            font-size: small;
            margin: 0 !important;
            border: 0px solid black;
        }
        /* .table-breaked {
            page-break-inside: avoid;
        } */
    }
    .text_report {
        border: 3px solid black;
        margin: 1rem !important;
    }
</style>
